<div class="header" [class.event-operation-header]="isEventOperationPage">
  <div class="left">
    <img src="assets/logo.png" class="logo">
    @if ((auth.loggedIn | async)) {
      <nav class="header-nav">
        <a class="menu-large"
           [routerLink]="['/myevent']"
           routerLinkActive="active">
          <div>MYイベント</div>
        </a>

        <a class="menu-large"
           [routerLink]="['/event-search']"
           routerLinkActive="active">
          <div>イベント検索</div>
        </a>

        <a class="menu-large"
           [routerLink]="['/union-consultation']"
           routerLinkActive="active">
          <div>組合相談</div>
        </a>
      </nav>
    }
  </div>

  <div class="right">
    @if (!(auth.loggedIn | async)) {
      <button
      mat-button
      class="name-btn dummy"
      disabled
    >
      {{ companyName$ | async }}
    </button>
    }

    @if ((auth.loggedIn | async)) {
      <button
      mat-button
      class="name-btn"
      [matMenuTriggerFor]="menu"
      aria-label="組織メニュー"
    >
      <span class="company-name">{{ companyName$ | async }}</span>
      <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
    </button>
        <mat-menu #menu="matMenu" xPosition="before" class="header-menu-dropdown">
          @if (auth.hasAuth(2)) {
            <button mat-menu-item (click)="onOrganizationAccount()">アカウント管理</button>
          }
          @if (auth.hasAuth(1)) {
            <button mat-menu-item (click)="onOrganizationAbout()">組織情報</button>
            <button mat-menu-item (click)="onMasterSettings()">マスタ設定</button>
          }
          <button mat-menu-item (click)="onAccountAbout()">個人設定</button>
          <button mat-menu-item (click)="onLogout()">ログアウト</button>
        </mat-menu>
    }
  </div>
</div>
